<div *ngIf="show"
     class="fixed inset-0 z-40 flex items-center justify-center bg-black/60 p-4"
     (click)="close()">
  <div class="w-full max-w-4xl max-h-[92vh] flex flex-col bg-white dark:bg-app-black-100 rounded-lg shadow-2xl border border-gray-200 dark:border-[#434863] overflow-hidden"
       (click)="$event.stopPropagation()">

    <!-- Header -->
    <div class="flex items-center gap-3 px-5 py-3 border-b border-gray-200 dark:border-[#434863]">
      <i class="fa-solid fa-envelope-circle-check text-app-teal-100 text-lg"></i>
      <div class="flex-1">
        <div class="text-base font-semibold text-gray-900 dark:text-white">Send Welcome Email</div>
        <div class="text-xs text-gray-500 dark:text-gray-400">
          {{ users.length }} user<span *ngIf="users.length !== 1">s</span> selected
          <span *ngIf="preview"> ·
            <strong class="text-emerald-500">{{ deliverableCount }}</strong> will send,
            <strong class="text-amber-500">{{ preview.skipped.count }}</strong> skipped
          </span>
        </div>
      </div>
      <button type="button" class="dark-btn dark-btn-sm" (click)="close()" [disabled]="sending">
        <i class="fa-solid fa-xmark"></i>
      </button>
    </div>

    <!-- Loading -->
    <div *ngIf="loading" class="flex-1 flex items-center justify-center p-10 text-sm text-gray-500 dark:text-gray-400">
      <i class="fa-solid fa-spinner fa-spin mr-2"></i> Rendering preview…
    </div>

    <!-- Content -->
    <div *ngIf="!loading && preview" class="flex-1 min-h-0 flex flex-col">

      <!-- Tab strip -->
      <div class="flex border-b border-gray-200 dark:border-[#434863] bg-gray-50 dark:bg-app-black-100">
        <button type="button"
                class="px-4 py-2 text-sm font-medium border-r border-gray-200 dark:border-[#434863] transition"
                [ngClass]="activeTab === 'a'
                  ? 'bg-white dark:bg-app-blue-100/40 text-app-teal-100 border-b-2 border-b-app-teal-100'
                  : 'text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-app-blue-100/20'"
                (click)="setTab('a')">
          <i class="fa-solid fa-key mr-1 text-xs"></i>
          A · Magic Link
          <span class="ml-1 text-xs opacity-80">({{ preview.a.count }})</span>
        </button>
        <button type="button"
                class="px-4 py-2 text-sm font-medium border-r border-gray-200 dark:border-[#434863] transition"
                [ngClass]="activeTab === 'b'
                  ? 'bg-white dark:bg-app-blue-100/40 text-app-teal-100 border-b-2 border-b-app-teal-100'
                  : 'text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-app-blue-100/20'"
                (click)="setTab('b')">
          <i class="fa-solid fa-door-open mr-1 text-xs"></i>
          B · Branded Activation
          <span class="ml-1 text-xs opacity-80">({{ preview.b.count }})</span>
        </button>
        <button type="button"
                *ngIf="preview.skipped.count > 0"
                class="px-4 py-2 text-sm font-medium border-r border-gray-200 dark:border-[#434863] transition"
                [ngClass]="activeTab === 'skipped'
                  ? 'bg-white dark:bg-app-blue-100/40 text-amber-500 border-b-2 border-b-amber-500'
                  : 'text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-app-blue-100/20'"
                (click)="setTab('skipped')">
          <i class="fa-solid fa-triangle-exclamation mr-1 text-xs"></i>
          Skipped
          <span class="ml-1 text-xs opacity-80">({{ preview.skipped.count }})</span>
        </button>
      </div>

      <!-- Tab body -->
      <div class="flex-1 min-h-0 overflow-y-auto p-4 space-y-3">

        <!-- A: magic-link -->
        <ng-container *ngIf="activeTab === 'a'">
          <div *ngIf="preview.a.count === 0" class="text-sm text-gray-500 dark:text-gray-400 italic p-4">
            No users will receive the magic-link variant. All selected users either already have a
            set password (they'll get the branded activation email — see B) or were skipped.
          </div>
          <div *ngIf="preview.a.count > 0" class="space-y-3">
            <div class="text-xs text-gray-500 dark:text-gray-400">
              <strong class="text-gray-900 dark:text-white">{{ preview.a.count }}</strong>
              user<span *ngIf="preview.a.count !== 1">s</span> will get this variant. Sample uses
              <code class="text-app-teal-100">{{ preview.a.users[0]?.email }}</code>'s data.
              Sending from <code>{{ preview.a.sample_from }}</code>,
              reply-to <code>{{ preview.a.sample_reply_to }}</code>.
            </div>
            <div class="text-sm">
              <span class="text-gray-500 dark:text-gray-400">Subject:</span>
              <code class="ml-1 text-gray-900 dark:text-white">{{ preview.a.sample_subject }}</code>
            </div>
            <iframe *ngIf="preview.a.sample_html"
                    class="w-full min-h-[440px] border border-gray-200 dark:border-[#434863] rounded bg-white"
                    sandbox="allow-same-origin"
                    [srcdoc]="preview.a.sample_html"></iframe>
            <details class="text-xs">
              <summary class="cursor-pointer text-gray-500 dark:text-gray-400 hover:text-app-teal-100">
                Recipient list ({{ preview.a.count }})
              </summary>
              <ul class="mt-2 space-y-1 font-mono text-[11px] text-gray-700 dark:text-gray-300 max-h-40 overflow-y-auto">
                <li *ngFor="let u of preview.a.users" class="flex gap-2">
                  <span class="text-gray-500 dark:text-gray-400">{{ u.customer_slug }}</span>
                  <span>{{ u.email }}</span>
                  <span class="text-gray-400 dark:text-gray-500">·</span>
                  <span class="text-app-teal-100">{{ u.scanner_labels.join(', ') }}</span>
                </li>
              </ul>
            </details>
          </div>
        </ng-container>

        <!-- B: branded activation -->
        <ng-container *ngIf="activeTab === 'b'">
          <div *ngIf="preview.b.count === 0" class="text-sm text-gray-500 dark:text-gray-400 italic p-4">
            No users will receive the branded activation variant. All selected users are either new
            or in FORCE_CHANGE_PASSWORD (they'll get the magic-link email — see A) or were skipped.
          </div>
          <div *ngIf="preview.b.count > 0" class="space-y-3">
            <div class="text-xs text-gray-500 dark:text-gray-400">
              <strong class="text-gray-900 dark:text-white">{{ preview.b.count }}</strong>
              user<span *ngIf="preview.b.count !== 1">s</span> will get this variant. Sample uses
              <code class="text-app-teal-100">{{ preview.b.users[0]?.email }}</code>'s data.
              Sending from <code>{{ preview.b.sample_from }}</code>,
              reply-to <code>{{ preview.b.sample_reply_to }}</code>.
            </div>
            <div class="text-sm">
              <span class="text-gray-500 dark:text-gray-400">Subject:</span>
              <code class="ml-1 text-gray-900 dark:text-white">{{ preview.b.sample_subject }}</code>
            </div>
            <iframe *ngIf="preview.b.sample_html"
                    class="w-full min-h-[440px] border border-gray-200 dark:border-[#434863] rounded bg-white"
                    sandbox="allow-same-origin"
                    [srcdoc]="preview.b.sample_html"></iframe>
            <details class="text-xs">
              <summary class="cursor-pointer text-gray-500 dark:text-gray-400 hover:text-app-teal-100">
                Recipient list ({{ preview.b.count }})
              </summary>
              <ul class="mt-2 space-y-1 font-mono text-[11px] text-gray-700 dark:text-gray-300 max-h-40 overflow-y-auto">
                <li *ngFor="let u of preview.b.users" class="flex gap-2">
                  <span class="text-gray-500 dark:text-gray-400">{{ u.customer_slug }}</span>
                  <span>{{ u.email }}</span>
                  <span class="text-gray-400 dark:text-gray-500">·</span>
                  <span class="text-app-teal-100">{{ u.scanner_labels.join(', ') }}</span>
                </li>
              </ul>
            </details>
          </div>
        </ng-container>

        <!-- Skipped -->
        <ng-container *ngIf="activeTab === 'skipped'">
          <div class="text-xs text-gray-500 dark:text-gray-400">
            These users will not receive a welcome email. Fix the underlying reason
            (missing <code>scanner_host</code>, legacy pool, etc.) and re-send if needed —
            OR click <strong>Copy magic link</strong> to grab the accept-invite URL for
            manual handoff (support ticket, DM, etc.). Mint bypasses SES entirely.
          </div>
          <ul class="mt-2 space-y-1 font-mono text-[11px] text-gray-700 dark:text-gray-300">
            <li *ngFor="let u of preview.skipped.users"
                class="flex items-center gap-2 py-1 border-b border-gray-100 dark:border-[#434863]/50">
              <span class="text-gray-500 dark:text-gray-400 w-32 truncate" [title]="u.customer_slug">{{ u.customer_slug }}</span>
              <span class="w-56 truncate" [title]="u.email">{{ u.email }}</span>
              <span class="text-amber-500 flex-1" [title]="u.reason">{{ u.reason }}</span>
              <button type="button"
                      class="dark-btn dark-btn-sm shrink-0"
                      [disabled]="isCopying(u.email)"
                      (click)="onCopyMagicLink(u)"
                      title="Mint a magic-link accept-invite URL for this user and copy it to the clipboard">
                <i class="fa-solid fa-key mr-1" [class.fa-spin]="isCopying(u.email)"
                   [class.fa-spinner]="isCopying(u.email)"></i>
                <span *ngIf="!isCopying(u.email)">Copy magic link</span>
                <span *ngIf="isCopying(u.email)">Minting…</span>
              </button>
            </li>
          </ul>
        </ng-container>
      </div>

      <!-- Footer -->
      <div class="flex items-center gap-2 px-5 py-3 border-t border-gray-200 dark:border-[#434863] bg-gray-50 dark:bg-app-black-100">
        <span class="text-xs text-gray-500 dark:text-gray-400">
          Bypasses each customer's <code>commerce_settings.welcome_email_enabled</code> flag —
          this is a manual admin action.
        </span>
        <button type="button" class="dark-btn dark-btn-sm ml-auto" (click)="close()" [disabled]="sending">
          Cancel
        </button>
        <button type="button" class="dark-btn dark-btn-primary dark-btn-sm"
                (click)="onSend()"
                [disabled]="sending || deliverableCount === 0">
          <i class="fa-solid fa-paper-plane mr-1"></i>
          <span *ngIf="!sending">Send {{ deliverableCount }} email<span *ngIf="deliverableCount !== 1">s</span></span>
          <span *ngIf="sending">Sending…</span>
        </button>
      </div>
    </div>
  </div>
</div>
